import './App.css';
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';

function App() {
  return (
    <div className="App">
      <main className="content">
        <div className="profile-section">
          <img src="/profile.jpg" alt="Profile" className="profile-image" />
          <div className="profile-text">
            <h1>Vivek Katara</h1>
            <div className="social-icons">
              <a href="https://github.com/VivKatara" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <FaGithub className="icon" />
              </a>
              <a href="https://www.linkedin.com/in/vivek-r-katara/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin className="icon" />
              </a>
              <a href="https://twitter.com/VivekKatara__" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter className="icon" />
              </a>
            </div>
            <p className="email">vivek.r.katara@gmail.com</p>
          </div>
        </div>
        
        <section className="about">
          <p>
            I’m an investor at <a href="https://www.altcap.com/" target="_blank" rel="noopener noreferrer">Alt Capital</a>, where we partner with exceptional early-stage founders as they build great companies.
          </p>
          <p>Prior to Alt, I was a software engineer at <a href="https://www.rippling.com/" target="_blank" rel="noopener noreferrer">Rippling</a> and studied Computer Science at Yale.</p>
          <p>I live in San Francisco and love meeting new people. If you'd like to connect, please reach out.</p>
        </section>
      </main>
    </div>
  );
}

export default App;
